import { API_V1 } from 'API/APIs/APIv1';
import { Genres } from 'enums';
import _ from 'lodash';
import Logger from 'logger';
import { ProfileValues } from '../types/profile.types';

export const createBoosterProject = async (
  projectName: string,
  occupation: string | undefined,
  profile: ProfileValues | undefined,
  genre: Genres,
  assessment: string | undefined,
  text?: string,
  offer?: any,
  content?: any,
  problems?: string
) => {
  try {
    const response = await API_V1.post('/projects/boosters', {
      projectName,
      occupation,
      profile,
      genre,
      assessment,
      text,
      offer,
      content,
      problems: problems !== '' ? problems : undefined,
    });

    return response.data;
  } catch (e) {
    Logger.trace('Error while creating booster project with ai generated text variants!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

export const saveBoosterProjectTextVariant = async (projectId: string, text: string, score?: number) => {
  try {
    const response = await API_V1.put(`/projects/boosters/${projectId}`, {
      text,
      score: !_.isNil(score) ? score : 0,
    });

    return response.data;
  } catch (e) {
    Logger.trace('Error while saving generated text to booster project!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

export const editBoosterProjectTextCreation = async (projectId: string, offer?: any, content?: any, problems?: string) => {
  try {
    const response = await API_V1.put(`/projects/boosters/${projectId}`, {
      offer,
      content,
      problems,
    });

    return response.data;
  } catch (e) {
    Logger.trace('Error while saving generated text to booster project!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

const getParams = (page?: number, total?: number, filter?: string, searchParam?: string) => {
  const paramObj: any = {};
  if (!_.isNil(page) && !_.isNil(total)) {
    paramObj.limit = total;
    paramObj.offset = page * total;
  }
  if (!_.isNil(searchParam) && searchParam !== '') {
    paramObj.q = searchParam;
  }
  if (!_.isNil(filter)) {
    paramObj.genre = filter;
  }

  return paramObj;
};

export const getAllBoosterProjects = async (page?: number, total?: number, genre?: string, searchParam?: string) => {
  try {
    const res = await API_V1.get('/projects/boosters', {
      params: getParams(page, total, genre, searchParam),
    });

    return res.data;
  } catch (e) {
    Logger.trace('Error while getting all booster projects!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

export const getBoosterProjectById = async (projectId: string) => {
  try {
    const res = await API_V1.get(`/projects/boosters/${projectId}`);

    return res.data;
  } catch (e) {
    Logger.trace('Error while getting single booster project!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

export const deleteBoosterProject = async (projectId: string) => {
  try {
    const res = await API_V1.delete(`/projects/boosters/${projectId}`);

    // Backend responds with 204 No Content on successful deletion.
    // Normalize to a truthy success payload so callers using `res && !res.error` work reliably.
    return _.isNil(res.data) ? { success: true } : res.data;
  } catch (e) {
    Logger.trace('Error while deleting a booster project!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};
